export type PagedResponse<T> = {
  count: number;
  page: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  pageSize: number;
  value: T[];
};

export interface ChatMessage {
  id: string;
  topicId: string;
  threadId: string;
  userId: string;
  externalId: string;
  senderName: string;
  content: string;
  messageType: string;
  metadata: { [key: string]: any };
  media: { [key: string]: string };
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date;
  readReceipts: { [key: string]: string };
  isPending?: boolean;
  hasFailed?: boolean;
}

export interface ChatMessageRequest {
  from?: Date;
  to?: Date;
  page?: number;
  pageSize?: number;
  sortBy?: string;
  sortDirection?: string;
}

export enum ThreadType {
  HealthManagerChannel = 'HealthManagerChannel',
  SupportChannel = 'SupportChannel',
  DoctorChannel = 'DoctorChannel',
  AiAssistant = 'AiAssistant',
}

export enum ChatTabFilter {
  ALL_CHATS = 'all_chats',
  MY_CHATS = 'my_chats',
  IN_QUEUE = 'in_queue',
}

export interface ChatThread {
  id: string;
  name: string;
  threadType: ThreadType;
  userIds: string[];
  topicIds: string[];
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date;
  ownerId?: string;
  ownerName?: string;
  latestSentMessage?: string;
  lastSentAt?: Date;
  assignees?: string[];
  labels?: string[];
  hasUnreadMessages?: boolean;
  unreadCount?: number;
}

export interface ChatThreadSearchRequest {
  value?: string;
  page?: number;
  pageSize?: number;
  sortBy?: string;
  sortDirection?: string;
  assigneeId?: string | null;
}
